import { z } from 'zod'
import { storageKeySchema, browserAssetUrlSchema } from '../helpers/asset-ref.js'

/**
 * Result of uploading an asset to private object storage.
 * - `key` — stable object key to persist on entities
 * - `url` — short-lived signed GET URL for immediate preview
 */
export const uploadResultDtoSchema = z.object({
  key: storageKeySchema,
  url: browserAssetUrlSchema,
})

export type UploadResultDto = z.infer<typeof uploadResultDtoSchema>
